// import react components
import { createContext } from "react";

const UserLogContext = createContext();

export default UserLogContext;
